export default __webpack_public_path__ + "static/media/Thong-bao_CTy-thuy-loi-Tra-Vinh_sắt-cống.ea9d4ed2.pdf";